import { listInvites, redeemInvite } from "./endpoints";

export { service } from "./endpoints";
export {
  INVITE_PATH_PREFIX,
  INVITES_PER_MEMBER,
  WaitlistInvite,
  WaitlistInviteCode,
} from "./schemas";

export const contract = {
  invites: { list: listInvites, redeem: redeemInvite },
} as const;
